import React from 'react';

import { Skeleton } from '@mui/material';

import CommitForm from '../../../../../components/CommitForm';
import ContentCard from '../../../../../components/ContentCard';
import { useUpdateStudentMutation } from '../../../../../services/students';
import { Student } from '../../../../../services/students/types';
import { Metadata } from '../../../../../services/types';
import useError from '../../../../../utils/react/hooks/useError';

const STUDENT_DETAILS_FIELDS = {
  school: {
    xs: 12,
    md: 7,
  },
  gradYear: {
    xs: 12,
    md: 5,
  },
  firstName: {
    xs: 12,
    md: 6,
  },
  lastName: {
    xs: 12,
    md: 6,
  },
  email: {
    xs: 12,
    md: 12,
  },
  birthday: {
    xs: 12,
    md: 6,
  },
  phoneNumber: {
    xs: 12,
    md: 6,
  },
  streetAddress: {
    xs: 12,
    md: 12,
  },
  country: {
    xs: 12,
    md: 6,
  },
  postcode: {
    xs: 12,
    md: 6,
  },
};

interface StudentDetailsCardProps {
  student?: Student,
  metadata?: Metadata
}

const StudentDetailsCard = ({ student, metadata }: StudentDetailsCardProps) => {
  const [updateStudent,
    { isLoading: isStudentUpdateLoading,
      isError: isStudentUpdateError,
      error: studentUpdateError }] = useUpdateStudentMutation();

  useError(isStudentUpdateError, studentUpdateError);

  if (!student) {
    return (
      <Skeleton variant="rectangular" height={128} />
    );
  }

  return (
    <ContentCard variant="outlined" title="Student Details">
      <CommitForm
        data={student}
        metadata={metadata}
        fields={STUDENT_DETAILS_FIELDS}
        onSubmit={async (values) => updateStudent({
          studentId: student.id,
          newAttributes: values,
        })}
        isSubmitLoading={isStudentUpdateLoading}
        autoSubmit
      />
    </ContentCard>
  );
};

export default StudentDetailsCard;
